<template>
    <div
        class="form-group"
        :class="[
            { active: moveLabelToTop },
            parentClass,
        ]"
    >
        <label class="form-group-label" :for="uniqueId">
            {{ label }}
        </label>
        <div class="input-group">
            <input
                v-bind="$attrs"
                @change="handleChange($event.target.value)"
                @focusin="focus = true"
                @focusout="focus = false"
                :value="inputValue"
                :placeholder="label"
                :class="{ 'number-input': smaller }"
                :disabled="disabled"
                class="form-control"
                type="number"
                step="any"
            >
        </div>
        <input
            type="hidden"
            :name="name"
            :value="inputValue"
            :disabled="disabled"
        >
    </div>
</template>

<script>
    export default {
        name: 'UiInputNumber',
        inheritAttrs: false,
        props: {
            value: {
                type: [Number, String],
                default: '',
            },
            label: {
                type: String,
                default: 'Label',
            },
            name: {
                type: String,
                default: 'price',
            },
            smaller: {
                type: Boolean,
                default: false,
            },
            parentClass: {
                type: String,
                default: '',
            },
            unit: {
                type: String,
                default: '',
            },
            forceInteger: {
                type: Boolean,
                default: false,
            },
            precision: {
                type: Number,
                default: 2,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                inputValue: '',
                focus: false,
            };
        },
        computed: {
            moveLabelToTop() {
                return this.focus || this.inputValue !== '';
            },

            uniqueId() {
                return this._uid;
            },
        },
        mounted() {
            this.updateInputValue();
        },
        methods: {
            updateInputValue() {
                this.inputValue = this.value || this.value === 0
                    ? +Number(this.value).toFixed(this.precision)
                    : '';
            },

            handleChange(value) {
                let newValue = value.toString().trim().replace(',', '.');

                if (!isNaN(Number(newValue)) && newValue !== '') {
                    newValue = +Number(newValue).toFixed(this.precision);
                } else {
                    newValue = '';
                }

                this.inputValue = newValue;
                this.$emit('input', newValue);
            },
        },
        watch: {
            value() {
                this.updateInputValue();
            },
        },
    };
</script>

<style lang="scss" scoped>
    input[type=number] {
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }
    }
</style>
